import { render, staticRenderFns } from "./TheSponsorInterest.vue?vue&type=template&id=5e640e2d&"
import script from "./TheSponsorInterest.vue?vue&type=script&lang=js&"
export * from "./TheSponsorInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports